const constEvent = {
  ADDED_TO_CART: 'added-to-cart',
  ADDED_TO_CART_LGC: 'added-to-cart-lgc',
  ADDED_TO_CART_HEPATOCYTE: 'added-to-cart-hepatocyte',
  ADDED_TO_LIST: 'added-to-list',
  COMPARE_PRODUCTS: 'compare-products',
  COMPARE_PREVIEW: 'compare-products',
  COMPARE_ALTERNATIVE_PRODUCTS: 'compare-alternative-products',
  CHECKOUT_NOW: 'handle-checkout-now',
  REMOVED_FROM_CART: 'removed-from-cart',
  CART_MODAL_SHOWN: 'cart-modal-shown',
  SHOW_MODAL_LOGIN: 'show-modal-login',
  ELOQUA_FORM_SUMBITTED: 'eloqua-form-submitted',
  FORM_SUCCESSFULLY_SUBMITTED: 'form-successfully-submitted',
  OPEN_ELOQUA_MODAL: 'open-eloqua-modal',
  OPEN_ELOQUA_IFRAME_MODAL: 'open-eloqua-iframe-modal',
  CLOSE_ELOQUA_IFRAME_MODAL: 'close-eloqua-iframe-modal',
  CLOSE_ELOQUA_MODAL: 'close-eloqua-modal',
  CLOSED_ELOQUA_MODAL: 'closed-eloqua-modal',
  OPEN_CONFIRMATION_MODAL: 'open-confirmation-modal',
  CLOSE_CONFIRMATION_MODAL: 'close-confirmation-modal',
  ACCEPT_CONFIRMATION: 'accept-confirmation',
  DENY_CONFIRMATION: 'confirmation-confirmation',
  SET_SAVED: 'set-saved',
  SHOW_MODAL_LINK_ACCOUNT: 'show-modal-link-account',
  SHOW_MODAL_EXISTING_PENDING_ACCOUNT_APLICATION:
    'show-modal-existing-pending-account-aplication',
  SHOW_MODAL_ADD_CONTACT: 'show-modal-add-contact',
  VIDEO_MODAL_OPENED: 'video-modal-opened',
  VIDEO_MODAL_CLOSED: 'video-modal-closed',
  COVEO_RESULTS_UPDATED: 'coveo-results-updated',
  COVEO_RESULTS_UPDATED_AJAX: 'coveo-results-updated-ajax',
  SHOW_MODAL_MISSING_CUSTOMER_ACCOUNT: 'show-modal-missing-customer-account',
  SHOW_MODAL_SELECT_END_USER_OR_RECIPIENT:
    'show-modal-select-end-user-or-recipient',
  CLOSE_MODAL_SELECT_END_USER_OR_RECIPIENT:
    'close-modal-select-end-user-or-recipient',
  SELECTED_END_USER_OR_RECIPIENT: 'selected-end-user-or-recipient',
  SHOW_SDS_MODAL: 'show-sds-modal',
  SHOW_MODAL_CHANGE_ADDRESS: 'show-modal-change-address',
  CLOSE_MODAL_CHANGE_ADDRESS: 'close-modal-change-address',
  UPDATED_DELIVERY_ADDRESS: 'updated-delivery-address',
  UPDATED_DELIVERY_ADDRESS_ON_CART_PAGE:
    'updated-delivery-address-on-cart-page',
  NEW_ACCOUNT_LINKED: 'new-account-linked',
  SHOW_QUICK_VIEW_MODAL: 'show-quick-view-modal',
  LOAD_QUICK_VIEW: 'load-quick-view',
  SHOW_ADD_TO_LIST_MODAL: 'show-add-to-list-modal',
  LOAD_ADD_TO_LIST_VIEW: 'load-add-to-list-view',
  ALLOW_OVERLAY_CLOSE_ADD_TO_LIST_MODAL:
    'allow-overlay-close-add-to-list-modal',
  SHOW_ADDRESS_VALIDATION_MODAL: 'show-address-validation-modal',
  CLOSE_ADDRESS_VALIDATION_MODAL: 'close-address-validation-modal',
  ADDRESS_VALIDATION_MODAL_SUBMITTED: 'address-validation-modal-submitted',
  ADD_TO_COMPARE_LIST: 'add-to-compare-list',
  COMPARE_COOKIE_NAME: 'compare-products',
  COMPARE_LOCAL_STORAGE_NAME: 'compare-products',
  SHOW_MODAL_CHANGE_ADDRESS_QUERY_STRING: 'show-change-address-modal',
  PDP_REMOVED_REFERENCES: 'pdp-removed-references',
  FLEX_MICROFORM_SUBMIT: 'flex-microform-submit',
  SHOW_MODAL_STR_DATABASE_SEARCH_LOADING:
    'show-modal-str-database-search-loading',
  CLOSE_MODAL_STR_DATABASE_SEARCH_LOADING:
    'close-modal-str-database-search-loading',
  STR_DATABASE_SEARCH_LOADING_SEARCH_VIEW: 'str-database-search-loading-search',
  STR_DATABASE_SEARCH_LOADING_CART_VIEW: 'str-database-search-loading-cart',
  STR_DATABASE_SEARCH_LOADING_RUN_REACT:
    'str-database-search-loading-run-react',
  STR_DATABASE_SEARCH_LOADING_RESET_REACT:
    'str-database-search-loading-reset-react',
  SHOW_STR_DATABASE_SEARCH_DISCLAIMER: 'show-str-database-search-disclaimer',
  STR_DATABASE_SEARCH_DISABLE_ENABLE_BTNS:
    'str-database-search-disable-enable-btns',
  CONTACT_FORM_UPDATED: 'contact-form-updated',
  ON_SUBMIT_BILLING_INFORMATION: 'on-submit-billing-information',
  RESET_STR_DATABASE_FORM: 'reset-str-database-form',
  CONVERT_TO_QUOTE_TRIGGER: 'convert-to-quote-trigger',
  MODIFY_QUOTE_TRIGGER: 'modify-quote-trigger',
  REMOVED_COMPARE_PRODUCT: 'removed-compare-product',
  MODAL_QUICK_VIEW_CONTAINER_NO_IMAGES: 'modal-quick-view-container--no-images',
  UPDATE_CART_INDICATOR: 'update-cart-indicator',
  SHOW_ACCOUNT_VERIFICATION_MODAL: 'show-account-verification-modal',
  CLOSE_ACCOUNT_VERIFICATION_MODAL: 'close-account-verification-modal',
  ACCOUNT_VERIFICATION_MODAL_SUBMITTED: 'account-verification-modal-submitted'
};

export { constEvent };
